export { default as ProductsIndexPageMenuWrapper } from './ProductsIndexPageMenuWrapper';
